import * as Yup from "yup";

const TARGET_CLIENT_ID = "69afdc065323c68fd76cdabf";

export const getDealValidationSchema = (userId) => {
  const isTargetClient = userId === TARGET_CLIENT_ID;
  return Yup.object({
    mobile: Yup.string()
      .transform((v) => (v ? v.replace(/\s+/g, "") : v))
      .nullable(),
    email: Yup.string().email("Invalid email address").nullable(),
    machineNumber: isTargetClient
      ? Yup.string().required("Machine ID is required")
      : Yup.string().nullable(),
    complaintStatus: isTargetClient
      ? Yup.string().required("Status is required")
      : Yup.string().nullable(),
  });
};

// Keep backward-compat alias (uses no extra validation)
export const dealValidationSchema = getDealValidationSchema("");

export const stageValidationSchema = Yup.object({
  name: Yup.string()
    .required("Stage name is required")
    .min(2, "Stage name must be at least 2 characters")
    .max(50, "Stage name must be less than 50 characters"),
  color: Yup.string()
    .required("Color is required")
    .matches(/^#[0-9A-F]{6}$/i, "Must be a valid hex color"),
});

export const companyValidationSchema = Yup.object({
  name: Yup.string()
    .required("Company name is required")
    .min(2, "Company name must be at least 2 characters")
    .max(100, "Company name must be less than 100 characters"),
  phone: Yup.string().matches(
    /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
    "Invalid phone number format"
  ),
  website: Yup.string().url("Invalid URL format"),
});

export const contactValidationSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email"),
  phone: Yup.string().matches(/^[0-9+\-\s()]+$/, "Invalid phone number"),
});
